import React from "react";

import { GoogleLogin } from "react-google-login";
import { withRouter } from "react-router";
import { Api } from "./../utils/api";

const clientId =
  "230770975881-f5ijmnce4thkh0fli42csfmtdip5ufaa.apps.googleusercontent.com";

class LoginComponent extends React.Component {
  state = {
    auth2: null,
  };

  constructor() {
    super();
    this.api = new Api();
    this.authWithOps = this.authWithOps.bind(this);
  }

  authWithOps(result) {
    return this.api.authWithOps(result).then(() => {
      window.location.replace("/");
    });
  }

  render() {
    return (
      <div>
        <GoogleLogin
          clientId={clientId}
          prompt="consent"
          responseType="code"
          onSuccess={this.authWithOps.bind(this)}
        />
      </div>
    );
  }
}

export default withRouter(LoginComponent);
